<template>
	<el-dialog
		:visible.sync="visible"
		:show-close="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		class="role-dialog"
		width="350px">
		<span slot="title" class="dialog-title">
			<span>{{title}}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false">
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
            <el-form-item label="数据编码" prop="code">
                <el-input v-model="dataForm.code" placeholder="数据编码" maxlength="32" :disabled="disabled"></el-input>
            </el-form-item>
			<el-form-item label="数据类别名称" prop="name">
                <el-input v-model="dataForm.name" placeholder="数据类别名称" maxlength="32"></el-input>
            </el-form-item>
        </el-form>
		<span slot="footer" class="dialog-footer">
			<el-button class="submit-btn" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from '@/utils/debounce'
export default {
	data() {
		return {
			title: '新增数据类别',
			visible: false,
			disabled: false,
			submitUrl: 'sysDataAdd',
			dataForm: {
				code: '',
				name: ''
			},
			dataRule: {
				code: [
					{required: true,message: '数据编码不能为空', trigger: "blur"}
				],
				name: [
					{required: true,message: '数据类别名称不能为空', trigger: "blur"}
				]
			}
		}
	},
	methods: {
		init(data) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				if(data == 'add') {
					this.title = '新增数据类别';
					this.disabled = false;
					this.submitUrl = 'sysDataAdd';
				}else {
					this.title = '修改数据类别';
					this.disabled = true;
					this.dataForm.code = data.code;
					this.dataForm.name = data.name;
					this.submitUrl = 'sysDataUpdate';
				}
			})
		},
		submit:debounce(function() {
			if(this.visible == false) {
				return
			}
			this.$refs['dataForm'].validate(valid => {
				if (valid) {
					let that = this;
					that.$request.post(
						that.submitUrl,
						true,
						that.dataForm,
						function (r) {
							if (r.code == "0") {
								that.visible = false;
								that.$emit('getDataList');
								that.$message.success('保存成功');
							} else {
								that.$message.error(r.msg);
							}
						}
					);
				} else {
					return false;
				}
			});
		},1000)
	}
}
</script>
<style lang="scss" scoped>
.dialog-title{
	display: block;
	text-align: center;
	span{
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img{
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.el-form-item{
	margin-bottom: 10px;
}
.submit-btn{
	width: 100%;
	background-color: #117FFC;
	color: #fff;
}
.role-dialog /deep/ .el-dialog{
	border-radius: 10px !important;
}
.role-dialog /deep/ .el-dialog__body{
	padding: 0 20px !important;
}
.role-dialog /deep/ .el-form-item__label{
	padding: 0 !important;
}
.role-dialog /deep/ .el-dialog__footer{
	padding: 20px 20px 40px !important;
}
</style>
